An opaque identifier for GraphQL objects.

The `value` has a maximum length of 255 characters,
and will always be representable with 255 bytes in UTF-8 encoding.
